import { useQuery } from '@tanstack/vue-query'

import { explorerApi } from '~/api/client'
import { EvmBlockSummaryInfo } from '~/api/repository'
import { blockSummaryKey } from '~/api/service/query-keys.const'

export const useFetchBlockSummary = (size: number) => {
  return useQuery([ ...blockSummaryKey ], (): Promise<Array<ViewBlockSummaryInfo>> => {
    return explorerApi.blockController.getBlockSummaryList({ 
      requestBody: {
        size: size
      }
     })
      .then((res: Array<EvmBlockSummaryInfo>) => {
        return blockSummaryDto(res)
      })
  })
}

export type ViewBlockSummaryInfo = EvmBlockSummaryInfo & {
  blockNumber: string;
  gasUsed: string;
  gasUsedPercent: string;
  gasLimit: string;
  age: string;
  trxCount: string;
  blockReward: string;
}

const blockSummaryDto = (array: Array<EvmBlockSummaryInfo>): Array<ViewBlockSummaryInfo> => {
  return {
    ...array.map((item: EvmBlockSummaryInfo) => {
      return {
        ...item,
        blockNumber: item.BNO,
        gasUsed: setComma(item.GU),
        gasUsedPercent: setComma(item.GUP),
        gasLimit: setComma(item.GL),
        age: item.AG,
        trxCount: item.TRXCNT,
        blockReward: setComma(item.BR)
      }
    })
  }
}